/* ===========================================================================
 * Retailer: Seal customer portal helpers (one-tap cancel, 13 Oct 2026)
 * ===========================================================================
 * Theme asset assets/retailer-seal-portal.js, loaded from layout/theme.liquid
 * ONLY on /a/subscriptions pages (Seal's portal renders inside our layout via
 * Seal's app proxy). Three jobs, nothing else:
 *
 *  1. Signed-out text. Seal's "You are not logged in." becomes a line that
 *     links the no-password email sign-in (/a/subscriptions/login) and the
 *     password sign-in (/account/login), in all 28 store locales (Seal only
 *     has 17 and showed the rest English). Links keep the shopper's locale
 *     prefix. Set here only; Seal admin is untouched. DOM only.
 *  2. A visible Cancel on each live row of Seal's list (the row's own manage
 *     link + action=cancel_subscription, Seal's documented quick action that
 *     opens its "Are you sure" box). Members who arrive by Seal's email link
 *     land on this list, and its rows had no visible button.
 *  3. Seal's own cancel request fails silently. If it errors, show "email us
 *     and we'll cancel it for you" and post one log row
 *     (/apps/retailer-plus/cancel-log, Shopify-signed app proxy). Never blocks,
 *     delays or changes Seal's request.
 *
 * No cancel hold, nothing sent to Seal, no data read beyond the page.
 * ========================================================================= */
(function () {
  "use strict";
  if (window.__rtlSealPortal) return;
  window.__rtlSealPortal = true;
  if (location.pathname.indexOf("/a/subscriptions") === -1) return;

  var SUPPORT = "support@theretailer.com.au";
  var NOT_SIGNED_IN = {
 "ar": "لم تسجّل الدخول. <a href=\"/a/subscriptions/login\">أرسل لي رابط تسجيل الدخول</a> (دون كلمة مرور) أو <a href=\"/account/login\">سجّل الدخول بكلمة المرور</a>.",
 "bg": "Не сте влезли в профила си. <a href=\"/a/subscriptions/login\">Изпратете ми линк за вход</a> (без парола) или <a href=\"/account/login\">влезте с паролата си</a>.",
 "cs": "Nejste přihlášeni. <a href=\"/a/subscriptions/login\">Pošlete mi odkaz pro přihlášení</a> (heslo není potřeba) nebo se <a href=\"/account/login\">přihlaste heslem</a>.",
 "da": "Du er ikke logget ind. <a href=\"/a/subscriptions/login\">Få et login-link på mail</a> (ingen adgangskode nødvendig) eller <a href=\"/account/login\">log ind med din adgangskode</a>.",
 "de": "Du bist nicht angemeldet. <a href=\"/a/subscriptions/login\">Anmeldelink per E-Mail senden</a> (kein Passwort nötig) oder <a href=\"/account/login\">mit Passwort anmelden</a>.",
 "el": "Δεν έχετε συνδεθεί. <a href=\"/a/subscriptions/login\">Στείλτε μου σύνδεσμο σύνδεσης</a> (χωρίς κωδικό) ή <a href=\"/account/login\">συνδεθείτε με τον κωδικό σας</a>.",
 "en": "You're not signed in. <a href=\"/a/subscriptions/login\">Email me a sign-in link</a> (no password needed) or <a href=\"/account/login\">sign in with your password</a>.",
 "es": "No has iniciado sesión. <a href=\"/a/subscriptions/login\">Recibe un enlace de acceso por correo</a> (sin contraseña) o <a href=\"/account/login\">inicia sesión con tu contraseña</a>.",
 "et": "Sa ei ole sisse logitud. <a href=\"/a/subscriptions/login\">Saada mulle sisselogimislink</a> (parooli pole vaja) või <a href=\"/account/login\">logi sisse oma parooliga</a>.",
 "fi": "Et ole kirjautunut sisään. <a href=\"/a/subscriptions/login\">Lähetä minulle kirjautumislinkki</a> (salasanaa ei tarvita) tai <a href=\"/account/login\">kirjaudu salasanallasi</a>.",
 "fr": "Vous n'êtes pas connecté. <a href=\"/a/subscriptions/login\">Recevez un lien de connexion par e-mail</a> (sans mot de passe) ou <a href=\"/account/login\">connectez-vous avec votre mot de passe</a>.",
 "he": "לא התחברתם. <a href=\"/a/subscriptions/login\">שלחו לי קישור התחברות</a> (בלי סיסמה) או <a href=\"/account/login\">התחברו עם סיסמה</a>.",
 "hr": "Niste prijavljeni. <a href=\"/a/subscriptions/login\">Pošaljite mi poveznicu za prijavu</a> (lozinka nije potrebna) ili se <a href=\"/account/login\">prijavite lozinkom</a>.",
 "hu": "Nem vagy bejelentkezve. <a href=\"/a/subscriptions/login\">Kérek egy belépési linket e-mailben</a> (jelszó nélkül) vagy <a href=\"/account/login\">lépj be a jelszavaddal</a>.",
 "it": "Non hai effettuato l'accesso. <a href=\"/a/subscriptions/login\">Ricevi un link di accesso via email</a> (senza password) oppure <a href=\"/account/login\">accedi con la password</a>.",
 "ja": "ログインしていません。<a href=\"/a/subscriptions/login\">ログイン用リンクをメールで受け取る</a>（パスワード不要）か、<a href=\"/account/login\">パスワードでログイン</a>してください。",
 "ko": "로그인되어 있지 않습니다. <a href=\"/a/subscriptions/login\">로그인 링크를 이메일로 받거나</a>(비밀번호 필요 없음) <a href=\"/account/login\">비밀번호로 로그인</a>하세요.",
 "lt": "Nesate prisijungę. <a href=\"/a/subscriptions/login\">Atsiųskite man prisijungimo nuorodą</a> (slaptažodžio nereikia) arba <a href=\"/account/login\">prisijunkite slaptažodžiu</a>.",
 "lv": "Tu neesi pieteicies. <a href=\"/a/subscriptions/login\">Saņem pieteikšanās saiti e-pastā</a> (parole nav vajadzīga) vai <a href=\"/account/login\">piesakies ar paroli</a>.",
 "nl": "Je bent niet ingelogd. <a href=\"/a/subscriptions/login\">Mail me een inloglink</a> (geen wachtwoord nodig) of <a href=\"/account/login\">log in met je wachtwoord</a>.",
 "pl": "Nie jesteś zalogowany. <a href=\"/a/subscriptions/login\">Wyślij mi link do logowania</a> (bez hasła) lub <a href=\"/account/login\">zaloguj się hasłem</a>.",
 "pt-BR": "Você não está logado. <a href=\"/a/subscriptions/login\">Receber link de acesso por e-mail</a> (sem senha) ou <a href=\"/account/login\">entrar com sua senha</a>.",
 "pt-PT": "Não tem sessão iniciada. <a href=\"/a/subscriptions/login\">Receber um link de acesso por e-mail</a> (sem palavra-passe) ou <a href=\"/account/login\">iniciar sessão com a palavra-passe</a>.",
 "ro": "Nu ești conectat. <a href=\"/a/subscriptions/login\">Trimite-mi un link de conectare</a> (fără parolă) sau <a href=\"/account/login\">conectează-te cu parola</a>.",
 "sk": "Nie ste prihlásení. <a href=\"/a/subscriptions/login\">Pošlite mi odkaz na prihlásenie</a> (heslo netreba) alebo sa <a href=\"/account/login\">prihláste heslom</a>.",
 "sl": "Niste prijavljeni. <a href=\"/a/subscriptions/login\">Pošljite mi povezavo za prijavo</a> (geslo ni potrebno) ali se <a href=\"/account/login\">prijavite z geslom</a>.",
 "sv": "Du är inte inloggad. <a href=\"/a/subscriptions/login\">Mejla mig en inloggningslänk</a> (inget lösenord behövs) eller <a href=\"/account/login\">logga in med ditt lösenord</a>.",
 "zh-TW": "您尚未登入。<a href=\"/a/subscriptions/login\">寄送登入連結給我</a>（不需密碼），或<a href=\"/account/login\">使用密碼登入</a>。"
};
  var FAIL = {
 "ar": "لم تتم العملية. راسلنا على {email} وسنلغيها نيابةً عنك.",
 "bg": "Не се получи. Пишете на {email} и ние ще го прекратим вместо вас.",
 "cs": "To se nepovedlo. Napište na {email} a zrušíme ho za vás.",
 "da": "Det gik ikke igennem. Skriv til {email}, så opsiger vi det for dig.",
 "de": "Das hat nicht geklappt. Schreib an {email} und wir kündigen deine Mitgliedschaft für dich.",
 "el": "Δεν ολοκληρώθηκε. Στείλτε email στο {email} και την ακυρώνουμε εμείς για εσάς.",
 "en": "That didn't go through. Email {email} and we'll cancel it for you.",
 "es": "No se ha podido completar. Escribe a {email} y la cancelamos por ti.",
 "et": "See ei õnnestunud. Kirjuta aadressile {email} ja me lõpetame selle sinu eest.",
 "fi": "Se ei onnistunut. Lähetä sähköpostia osoitteeseen {email}, niin peruutamme sen puolestasi.",
 "fr": "Cela n'a pas fonctionné. Écrivez à {email} et nous le résilierons pour vous.",
 "he": "זה לא עבר. כתבו לנו ל-{email} ונבטל אותו בשבילכם.",
 "hr": "To nije uspjelo. Pišite na {email} i otkazat ćemo ga umjesto vas.",
 "hu": "Ez nem sikerült. Írj nekünk: {email}, és lemondjuk helyetted.",
 "it": "Non è andata a buon fine. Scrivi a {email} e lo disdiciamo noi per te.",
 "ja": "手続きが完了しませんでした。{email} までご連絡いただければ、こちらで解約いたします。",
 "ko": "처리되지 않았습니다. {email}로 이메일을 보내주시면 대신 해지해 드립니다.",
 "lt": "Nepavyko. Parašykite {email} ir mes ją atšauksime už jus.",
 "lv": "Tas neizdevās. Raksti uz {email}, un mēs to atcelsim tavā vietā.",
 "nl": "Dat is niet gelukt. Mail naar {email} en wij zeggen het voor je op.",
 "pl": "Nie udało się. Napisz na {email}, a anulujemy je za Ciebie.",
 "pt-BR": "Não deu certo. Escreva para {email} e a gente cancela para você.",
 "pt-PT": "Não foi possível concluir. Escreva para {email} e cancelamos por si.",
 "ro": "Nu a funcționat. Scrie-ne la {email} și îl anulăm noi pentru tine.",
 "sk": "To sa nepodarilo. Napíšte na {email} a zrušíme ho za vás.",
 "sl": "To ni uspelo. Pišite na {email} in ga prekličemo namesto vas.",
 "sv": "Det gick inte igenom. Mejla {email} så avslutar vi det åt dig.",
 "zh-TW": "未能完成。請寫信至 {email}，我們會為您取消。"
};
  var CANCEL_LABEL = {"ar": "إلغاء", "bg": "Прекрати", "cs": "Zrušit", "da": "Opsig", "de": "Kündigen", "el": "Ακύρωση", "en": "Cancel", "es": "Cancelar", "et": "Lõpeta", "fi": "Peruuta", "fr": "Résilier", "he": "ביטול", "hr": "Otkaži", "hu": "Lemondás", "it": "Disdici", "ja": "解約", "ko": "해지", "lt": "Atšaukti", "lv": "Atcelt", "nl": "Opzeggen", "pl": "Anuluj", "pt-BR": "Cancelar", "pt-PT": "Cancelar", "ro": "Anulează", "sk": "Zrušiť", "sl": "Prekliči", "sv": "Avsluta", "zh-TW": "取消"};
  var SUBJECT = {"ar": "إلغاء عضويتي في ⁦Retailer+⁩", "bg": "Прекратяване на моето Retailer+", "cs": "Zrušit moje Retailer+", "da": "Opsig mit Retailer+", "de": "Retailer+ kündigen", "el": "Ακύρωση του Retailer+ μου", "en": "Cancel my Retailer+", "es": "Cancelar mi Retailer+", "et": "Lõpeta minu Retailer+", "fi": "Peru Retailer+-jäsenyyteni", "fr": "Résilier mon Retailer+", "he": "ביטול המינוי שלי ל-⁦Retailer+⁩", "hr": "Otkazivanje mog Retailer+", "hu": "Retailer+ tagságom lemondása", "it": "Disdici il mio Retailer+", "ja": "Retailer+の解約希望", "ko": "Retailer+ 해지 요청", "lt": "Atšaukti mano Retailer+", "lv": "Atcelt manu Retailer+", "nl": "Mijn Retailer+ opzeggen", "pl": "Anuluj moje Retailer+", "pt-BR": "Cancelar meu Retailer+", "pt-PT": "Cancelar o meu Retailer+", "ro": "Anularea abonamentului meu Retailer+", "sk": "Zrušiť moje Retailer+", "sl": "Preklic mojega Retailer+", "sv": "Avsluta mitt Retailer+", "zh-TW": "取消我的 Retailer+"};

  function locale() {
    try { return String((window.Shopify && window.Shopify.locale) || "en"); } catch (e) { return "en"; }
  }
  function pick(table) {
    var l = locale();
    if (table[l]) return table[l];
    var plain = l.split("-")[0];
    for (var k in table) { if (k.split("-")[0] === plain && table[k]) return table[k]; }
    return table.en || null;
  }
  function log() { try { console.log.apply(console, ["[rtl-portal]"].concat([].slice.call(arguments))); } catch (e) {} }

  // ---------------------------------------------------- 1. signed-out text ---
  // Locale root ("/" or "/de-de/"), so both links stay in the shopper's language.
  function rootPrefix() {
    try {
      var r = String((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/");
      if (!/^\/([a-z]{2}(-[a-z0-9]{2,4})?\/)?$/i.test(r)) return "";
      return r.replace(/\/$/, "");
    } catch (e) { return ""; }
  }
  var nliHtml = (function () {
    var h = pick(NOT_SIGNED_IN);
    if (!h) return null;
    var root = rootPrefix();
    return root ? h.split('href="/').join('href="' + root + "/") : h;
  })();
  var nliApplied = 0;
  function applyNotSignedIn() {
    if (!nliHtml) return;
    var els = document.querySelectorAll('[data-seal-t="list_not_logged_in_text"]');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (el.__rtlText != null && el.textContent === el.__rtlText) continue; // ours is showing
      if (nliApplied > 30) return; // never fight Seal forever
      el.innerHTML = nliHtml;
      // Seal's portal CSS draws links exactly like body text: make both taps visible.
      var as = el.querySelectorAll("a");
      for (var j = 0; j < as.length; j++) {
        var st = as[j].style; // !important: Seal's portal CSS forces text-decoration:none on links
        st.setProperty("color", "inherit", "important");
        st.setProperty("text-decoration", "underline", "important");
        st.setProperty("text-underline-offset", "3px", "important");
        st.setProperty("font-weight", "700", "important");
      }
      var lc = locale().split("-")[0];
      if (lc === "ar" || lc === "he") el.setAttribute("dir", "rtl");
      el.__rtlText = el.textContent;
      el.setAttribute("data-rtl-nli", "1");
      nliApplied++;
    }
  }

  // ------------------------------------------------ 2. per-row Cancel button ---
  function withAction(href) {
    try {
      var u = new URL(href, location.href);
      u.searchParams.delete("action");
      u.searchParams.append("action", "cancel_subscription");
      return u.toString();
    } catch (e) { return null; }
  }
  function addRowCancels() {
    var rows = document.querySelectorAll(".seal-subscriptions-list .js-seal-clickable");
    for (var i = 0; i < rows.length; i++) {
      var row = rows[i];
      if (row.querySelector(".rtl-row-cancel")) continue;
      if (row.querySelector(".seal-sub-list-status-value.seal-red")) continue; // already cancelled
      var link = row.querySelector("a.seal-sub-id");
      var href = link && withAction(link.getAttribute("href"));
      if (!href) continue;
      var a = document.createElement("a");
      a.className = "rtl-row-cancel";
      a.href = href;
      a.textContent = pick(CANCEL_LABEL) || "Cancel";
      a.setAttribute("style", "display:inline-flex;align-items:center;justify-content:center;min-height:44px;min-width:104px;margin-top:10px;padding:10px 16px;border:1.5px solid #242424;border-radius:10px;background:#fff;color:#242424;font-weight:700;font-size:15px;line-height:1.2;text-decoration:none;");
      // Seal makes the whole row clickable (to the edit page); keep this tap ours.
      a.addEventListener("click", function (e) { e.stopPropagation(); });
      var wrap = document.createElement("div");
      wrap.className = "rtl-row-cancel-wrap";
      wrap.setAttribute("style", "width:100%;");
      wrap.appendChild(a);
      row.appendChild(wrap);
    }
  }

  // ------------------------------------------- 3. Seal cancel failure notice ---
  var noticeShown = false;
  function subId() {
    try {
      var s = window.sealsubscriptions && window.sealsubscriptions.subscription;
      if (s && s.id != null && /^\d{4,12}$/.test(String(s.id))) return String(s.id);
    } catch (e) {}
    return null;
  }
  function beacon(status) {
    try {
      var body = JSON.stringify({ subId: subId(), status: status });
      var url = "/apps/retailer-plus/cancel-log";
      if (navigator.sendBeacon && navigator.sendBeacon(url, new Blob([body], { type: "text/plain" }))) return;
      fetch(url, { method: "POST", body: body, keepalive: true, credentials: "omit" }).catch(function () {});
    } catch (e) {}
  }
  function showFailure(status) {
    beacon(status);
    if (noticeShown) return;
    noticeShown = true;
    try {
      var msg = String(pick(FAIL) || FAIL.en);
      var esc = function (s) { return s.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;"); };
      var mail = '<a href="mailto:' + SUPPORT + '?subject=' + encodeURIComponent(String(pick(SUBJECT) || SUBJECT.en)) + '" style="color:#fff;text-decoration:underline;font-weight:700">' + SUPPORT + "</a>";
      var box = document.createElement("div");
      box.id = "rtl-cancel-failed";
      box.setAttribute("role", "alert");
      var l = locale();
      if (l === "ar" || l === "he") box.setAttribute("dir", "rtl");
      box.setAttribute("style", "position:fixed;left:16px;right:16px;bottom:16px;z-index:2147483647;max-width:560px;margin:0 auto;background:#242424;color:#fff;border-radius:12px;padding:16px 44px 16px 18px;font-size:15px;line-height:1.5;box-shadow:0 10px 30px rgba(0,0,0,.3);font-family:inherit;");
      box.innerHTML = esc(msg).split("{email}").join(mail) +
        '<button type="button" aria-label="Close" style="position:absolute;top:8px;right:8px;width:32px;height:32px;border:0;background:transparent;color:#fff;font-size:22px;line-height:1;cursor:pointer">&times;</button>';
      box.querySelector("button").addEventListener("click", function () { box.parentNode && box.parentNode.removeChild(box); });
      document.body.appendChild(box);
      log("seal cancel failed:", status);
    } catch (e) {}
  }
  function isSealCancel(url, method, body) {
    try {
      if (String(method || "GET").toUpperCase() === "GET") return false;
      if (!/sealsubscriptions\.com/i.test(String(url)) || !/edit-subscription/i.test(String(url))) return false;
      var b = typeof body === "string" ? body : "";
      if (window.FormData && body instanceof FormData) { try { b = new URLSearchParams(body).toString(); } catch (e) { b = ""; } }
      else if (window.URLSearchParams && body instanceof URLSearchParams) b = body.toString();
      return /(^|&)cancel=(true|1)(&|$)/i.test(b);
    } catch (e) { return false; }
  }
  function judge(status, text) {
    if (!status || status >= 400) return "http_error";
    try { var j = JSON.parse(text); if (j && j.success === false) return "success_false"; } catch (e) {}
    return null;
  }
  try {
    var XO = XMLHttpRequest.prototype.open, XS = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (m, u) {
      try { this.__rtlM = m; this.__rtlU = u; } catch (e) {}
      return XO.apply(this, arguments);
    };
    XMLHttpRequest.prototype.send = function (body) {
      try {
        if (isSealCancel(this.__rtlU, this.__rtlM, body)) {
          var x = this;
          x.addEventListener("loadend", function () {
            if (x.__rtlDone) return;
            x.__rtlDone = true;
            var r = null;
            try { r = judge(x.status, x.responseType === "" || x.responseType === "text" ? x.responseText : ""); } catch (e) { r = "http_error"; }
            if (r) showFailure(r);
          });
          x.addEventListener("timeout", function () { if (!x.__rtlDone) { x.__rtlDone = true; showFailure("timeout"); } });
        }
      } catch (e) {}
      return XS.apply(this, arguments);
    };
  } catch (e) { log("xhr watch failed", e); }
  if (window.fetch) {
    var realFetch = window.fetch.bind(window);
    window.fetch = function (input, init) {
      var p = realFetch(input, init);
      try {
        var url = typeof input === "string" ? input : (input && input.url) || "";
        var method = (init && init.method) || (input && input.method) || "GET";
        if (isSealCancel(url, method, init && init.body)) {
          p.then(function (res) {
            return res.clone().text().then(function (t) { var r = judge(res.status, t); if (r) showFailure(r); });
          }, function () { showFailure("network_error"); });
        }
      } catch (e) {}
      return p;
    };
  }

  // ---------------------------------------------------------------- boot ---
  function run() { applyNotSignedIn(); addRowCancels(); }
  function boot() {
    run();
    try {
      var mo = new MutationObserver(function () { run(); });
      mo.observe(document.body, { childList: true, subtree: true, characterData: true });
      setTimeout(function () { try { mo.disconnect(); } catch (e) {} }, 60000);
    } catch (e) {}
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();

  window.__rtlPortal = { version: "2026-10-13", isSealCancel: isSealCancel, judge: judge, showFailure: showFailure, locale: locale };
})();
